// import React, { Component } from 'react'
import React, { useState, useEffect } from 'react'
import PropTypes from 'prop-types'
import { StaticQuery, graphql } from 'gatsby'

import Col from 'react-bootstrap/Col'
import Container from 'react-bootstrap/Container'
import Row from 'react-bootstrap/Row'

import CourseMenu from './course-menus/course-menu'
import Footer from '../footer'
import Header from '../header'
import HomeNav from '../home-nav'
import JumpDown from '../jump-down'
import SigninFormModal from '../forms/signin-form/signin-form-modal'
import StudentViewToggle from '../student-view-toggle'

import 'typeface-open-sans'
import 'typeface-lora'
import 'typeface-handlee'
import './layout.scss'

import isUserSignedIn from '../../auth/is-user-signed-in'
import axios from 'axios'

function Layout(props) {
  const [show_signin_modal, setShowSigninModal] = useState(false)
  const [authenticated, setAuthenticated] = useState(false)

  const axios_cancel_token = axios.CancelToken.source()

  useEffect(() => {
    let mounted = true

    async function checkIfSignedIn() {
      const is_signed_in = await isUserSignedIn(axios_cancel_token)
      if (mounted) {
        setAuthenticated(is_signed_in)
      }
    }

    checkIfSignedIn()

    return (() => { mounted = false })
  }, [])

  const setSignedIn = () => {
    props.setAuthenticated(true)
    setAuthenticated(true)
    setShowSigninModal(false)    
  }

  const setSignedOut = () => {
    props.setAuthenticated(false)
    setAuthenticated(false)
  }

  return (
    <StaticQuery
      query={graphql`
        query {
          site {
            siteMetadata {
              title
              author
              description
            }
          }
        }
      `}
      render={data => (
        <React.Fragment>
          <Container>
            <Row>
              <Header
                launchSignin={() => setShowSigninModal(true)}
                location={props.location}
                signOut={setSignedOut}
                authenticated={authenticated}
              />
            </Row>
          </Container>
          <Container className="d-flex flex-column" style={{minHeight: '100vh'}}>
            <Row
              style={{
                flex: "1",
                background: 'white',
                borderTopLeftRadius: '.25rem',
                borderTopRightRadius: '.25rem'
              }}
              className={props.className ? `pt-3 ${props.className}` : "pt-3"}
            >
              {authenticated && !props.no_student_view &&
                <StudentViewToggle
                  setStudentAccordionState={(state) => props.setStudentAccordionState(state)}
                />
              }
              {!authenticated && typeof window !== `undefined` && window.location.pathname !== '/' &&
                <React.Fragment>
                  <hr className="d-flex d-lg-none w-100 mt-6" />
                  <Col xs={12} className="d-flex d-lg-none justify-content-center">
                    <JumpDown target_id="main-content" size="sm">
                      Jump to Content&nbsp;<i className="fa fa-arrow-down"></i>
                    </JumpDown>
                  </Col>
                  <hr className="d-flex d-lg-none w-100 mb-3" />
                </React.Fragment>
              }
              {props.course &&
                <CourseMenu
                  authenticated={authenticated}
                  course={props.course}
                  location={props.location}
                />
              }
              {typeof window !== `undefined` && window.location.pathname !== '/' &&
                // <Col xs={12} md={8} lg={9} id="main-content">
                <Col xs={12} lg={9} id="main-content">
                  {props.children}
                </Col>
              }
              {typeof window !== `undefined` && window.location.pathname === '/' &&
                <Col xs={12} id="main-content">
                  {props.children}
                </Col>
              }
            </Row>
            {typeof window !== `undefined` && window.location.pathname === '/' &&
              <HomeNav />
            }
            <Footer
              location={props.location}
            />
            <SigninFormModal
              show={show_signin_modal}
              onHide={() => setShowSigninModal(false)}
              setSignedIn={setSignedIn}
              signed_in={authenticated}
            />
          </Container>
        </React.Fragment>
      )}
    />
  )
}

Layout.propTypes = {
  children: PropTypes.node.isRequired,
}

export default Layout
